export class SvgIcon {
    [key: string]: string
}

export const SVGICONDEFAULT: SvgIcon = {
    'accessibility-rounded': 'accessibility_rounded',
    'activity': 'activity',
    'achievement': 'achievement',
    'add': 'add',
    'add-700': 'add_700',
    'alert': 'alert',
    'alert_circle': 'alert_circle',
    'analytics': 'analytics',
    'app': 'matching',
    'arrow-drop-down-rounded-700': 'arrow_drop_down_rounded_700',
    'arrow-forward-ios-rounded': 'arrow_forward_ios_rounded',
    'arrow-outward-rounded': 'arrow_outward_rounded',
    'arrow_right': 'arrow_right',
    'article-rounded-fill': 'article_rounded_fill',
    'assessment': 'evaluation',
    'assign': 'assign',
    'assignment': 'assignment',
    'audio': 'audio',
    'apple': 'apple',
    'back': 'arrow_back',
    'book_open': 'book_open_outline',
    'brand': 'brand',
    'brand_square': 'brand-square',
    'chat_close': 'chat_close',
    'chat_happy': 'chat_happy',
    'chat_sad': 'chat_sad',
    'check': 'check',
    'chevron-right-rounded': 'chevron_right_rounded',
    'facebook':'facebook',
    'help': 'help',
    'class_add': 'class_add',
    'close': 'close',
    'close-700': 'close_700',
    'close-rounded': 'close_rounded',
    'collections_bookmark': 'transition',
    'contacts': 'classe',
    'corpus': 'corpus',
    'corpus_pdf': 'corpus',
    'correct': 'success',
    'cross': 'cross',
    'crt': 'reponsecourte',
    'dashboard': 'dashboard',
    'delete': 'delete',
    'document': 'document',
    'download': 'download_outline',
    'download-pdf': 'file_download',
    'drag': 'drag',
    'dropdown': 'dropdown',
    'earth': 'earth',
    'edit': 'edit',
    'educational-resources': 'for_further',
    'event-rounded-fill': 'event_rounded_fill',
    'event-upcoming-rounded-fill': 'event_upcoming_rounded_fill',
    'exit': 'exit',
    'expand-arrow': 'keyboard_arrow_right',
    'file_download': 'file_download',
    'fill_in_blanks': 'remplir_blancs',
    'flag': 'flag',
    'folder': 'folder',
    'followed': 'assignment',
    'free_answer': 'reponsecourte',
    'fullscreen': 'fullscreen',
    'fullscreen_circle': 'fullscreen_circle',
    'fullscreen_exit': 'fullscreen_exit',
    'funambule': 'funambule',
    'generateur': 'generateur',
    'gestioncompte': 'classe',
    'google':'google',
    'group': 'group',
    'heart': 'heart',
    'homepage': 'home',
    'home': 'home',
    'homework': 'devoir',
    'hourglass': 'hourglass',
    'icon_arrow_back': 'arrow_back',
    'icon-lesson-add': 'add',
    'icon_pdf': 'icon_pdf',
    'icon_progression_not_acquired': 'fill_progression_not_acquired',
    'icon_progression_to_do': 'fill_progression_to_do',
    'icon_progression_so_close': 'fill_progression_so_close',
    'icon_progression_acquired': 'fill_progression_acquired',
    'image': 'image',
    'info': 'info',
    'institution': 'institution',
    'institution_add': 'institution_add',
    'keyboard_arrow_up': 'keyboard_arrow_up',
    'keyboard_arrow_down': 'keyboard_arrow_down',
    'lessons': 'explore',
    'lock-rounded-fill': 'lock_rounded_fill',
    'log_out': 'log_out',
    'magnify': 'search',
    'markunread-mailbox-rounded-fill': 'markunread_mailbox_rounded_fill',
    'menu': 'menu',
    'montrer': 'montrer',
    'new_releases': 'document',
    'notifications': 'audio',
    'open-in-new-rounded': 'open_in_new_rounded',
    'ord': 'ordonnancement',
    'ordonnancement': 'ordonnancement',
    'outils2': 'outils2',
    'pdf': 'document',
    'photo': 'ressources',
    'play': 'play',
    'play-as-icon': 'play',
    'play-preview': 'visibility',
    'policy-rounded-fill':'policy_rounded_fill',
    'previous': 'arrow_left_alt_rounded',
    'print': 'print',
    'projects': 'projet',
    'qcm': 'qcm',
    'qcmu': 'qcmu',
    'qcu': 'qcmu',
    'rb': 'remplir_blancs',
    'recommendation': 'recommendation',
    'round_videoprojeter': 'round_videoprojeter',
    'round_videoprojeteroff': 'round_videoprojeteroff',
    'save': 'enregistrer',
    'search': 'search',
    'sort': 'sort',
    'step_done': 'step_done',
    'step_inprogress': 'step_inprogress',
    'step_pasfait': 'step_pasfait',
    'student_add': 'student_add',
    'submenu': 'submenu',
    'tools': 'outils',
    'tools-circle': 'cube_outline_circle',
    'trainer_add': 'trainer_add',
    'training': 'entrainement',
    'trala_btn': 'trala_btn',
    'trash': 'trash',
    'tune-rounded': 'tune_rounded',
    'user': 'user',
    'vf': 'vraifaux',
    'video': 'ressources',
    'videoprojeter': 'videoprojeter',
    'view_day': 'matching',
    'view_list': 'ordonnancement',
    'view_stream': 'remplir_blancs',
    'view_week': 'vraifaux',
    'visibility_legalnotice': 'visibility',
    'visibility_cgurgpd': 'visibility',
    'visibility_privacy': 'visibility',
    'visibility': 'visibility',
    'visibility_off': 'visibility_off',
    'virtual_class': 'virtual_class',
    'workgroup_add': 'workgroup_add',
    'wrong': 'failure',
    'expand': 'expand',
    'news': 'news',
    'accessibility': 'accessibility',
    'compass': 'compass',
    'chevron': 'chevron',
    'for_further': 'for_further',
    'code_sand_box': 'code_sand_box',
    'button-audio__icon': 'equalizer_1',
    'keyboard_tab_right': 'keyboard_tab_right',
    'keyboard_tab_left': 'keyboard_tab_left',
    'forward_to_inbox': 'forward_to_inbox',
    'event_upcoming': 'event_upcoming',
    'enhanced_encryption': 'enhanced_encryption',
    'close_1': 'close_1',
    'add_1': 'add_1',
    'user-review__dissatisfied': 'sentiment_dissatisfied',
    'user-review__satisfied': 'sentiment_satisfied',
    'user-review__very-dissatisfied': 'sentiment_sad',
    'user-review__very-satisfied': 'mood',
    'site_map': 'site_map',
};